import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { IMAGE_PROPS } from '@/helpers/picture-comp-helper';

// up until 600px screen widht, the backdrop is displayed 100%.
// above 600px, the backdrop will only have 50% of the screen width.
// that's why it could look like the image needs a higher image profile, but it doesn't actually.
// since we use the 1050px breakpoint in other areas, we should use this here as well.

export default /*#__PURE__*/_defineComponent({
  __name: 'PictureCompBackdrop',
  props: {
    imageUrl: null,
    alt: null
  },
  emits: ["imageLoad", "imageError"],
  setup(__props: any) {

const props = __props as {
	imageUrl: string;
	alt: string;
};

const SWITCH_WIDTH = 1050;
const MOBILE_PROFILE = 's640';
const DESKTOP_PROFILE = 's1440';
const IMAGE_PROP_FILTER = ['avif', 'webp', 'jpeg'];





function buildUrl(profile: string, extension = '') {
	return `${JW_CONFIG.IMAGESCALER_URL}${props.imageUrl
		.replace('{profile}', profile)
		.replace('.{format}', extension)}`;
}

const sources = computed(() =>
	IMAGE_PROP_FILTER.flatMap(key => {
		const imageProp = IMAGE_PROPS[key];

		return [
			{
				key: `${key}-mobile`,
				type: imageProp.type,
				media: `(max-width: ${SWITCH_WIDTH}px)`,
				srcset: buildUrl(MOBILE_PROFILE, imageProp.extension),
			},
			{
				key: `${key}-desktop`,
				type: imageProp.type,
				media: undefined,
				srcset: buildUrl(DESKTOP_PROFILE, imageProp.extension),
			},
		];
	})
);

const fallbackSrc = computed(() => buildUrl(MOBILE_PROFILE, IMAGE_PROPS.jpeg.extension));

return { __sfc: true,SWITCH_WIDTH, MOBILE_PROFILE, DESKTOP_PROFILE, IMAGE_PROP_FILTER, props, buildUrl, sources, fallbackSrc }
}

})